import styles from "css/components/tables/generic-table.module.css"
import { ReactElement, useState, useEffect } from "react";

export const NumberedView = ({ index, value }) => {
    return (
        <div className={styles.value}>
            <span className={styles.index}>{index + 1}. </span>
            <span>{value}</span>
        </div>
    )
}

type GenericTableProps = {
    style: any,
    columns: any,
    data: any,
    rowKey: string,
    renderHeader?: boolean,
    renderMoreActions?: boolean,
    createMoreActionCell?: any,
    rowClassName?: any
    doubleClickRowAction?: any
};

const Row = ({ row, idx, rowKey, rowClassName, doubleClickRowAction, columns, renderMoreActions, createMoreActionCell, isSelected, onRowSelect, disabled = false }) => {
    return (
        <tr
            key={row[rowKey]}
            className={`${rowClassName ? rowClassName(row, idx) : ''} ${isSelected ? styles.selectedRow : ''}`}
            onDoubleClick={() => doubleClickRowAction(row[rowKey])}
            onClick={() => onRowSelect(row[rowKey])}
            style={{ opacity: disabled ? 0.5 : 1 }}
        >
            {columns.map(col => (
                <td key={col.key} className={col.className}>
                    {col.render ? col.render(row[col.key], idx, row) : row[col.key]}
                </td>
            ))}
            {renderMoreActions && (
                createMoreActionCell(row[rowKey], isSelected)
            )}
        </tr>
    )
}

// TODO: Rename the style prop to be more specific
export const GenericTable = ({
    style,
    columns,
    data,
    rowKey,
    renderHeader,
    renderMoreActions,
    createMoreActionCell,
    rowClassName,
    doubleClickRowAction
}: GenericTableProps) => {
    const [selectedRowKey, setSelectedRowKey] = useState(null);

    // Handle clicking outside the table to unhighlight
    useEffect(() => {
        const handleClickOutside = (event) => {
            const tableContainer = event.target.closest(`.${styles.genericTableContainer}`);
            if (!tableContainer) {
                setSelectedRowKey(null);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const handleRowSelect = (rowKey) => {
        setSelectedRowKey(selectedRowKey === rowKey ? null : rowKey);
    };

    return (
        <div className={styles.genericTableContainer}>
            <table>
                {renderHeader && <thead>
                    <tr>
                        {columns.map(col => <th key={col.key}>{col.header}</th>)}
                        {renderMoreActions && <th></th>}
                    </tr>
                </thead>
                }
                <tbody style={style}>
                    {data.map((row, idx) => {
                        if (row.isDuplicating) {
                            return (
                                <Row
                                    key={row[rowKey]}
                                    row={row}
                                    idx={idx}
                                    rowKey={rowKey}
                                    rowClassName={rowClassName}
                                    doubleClickRowAction={doubleClickRowAction}
                                    columns={columns}
                                    renderMoreActions={renderMoreActions}
                                    createMoreActionCell={createMoreActionCell}
                                    isSelected={selectedRowKey === row[rowKey]}
                                    onRowSelect={handleRowSelect}
                                    disabled={true}
                                />
                            )
                        }
                        return (
                            <Row
                                key={row[rowKey]}
                                row={row}
                                idx={idx}
                                rowKey={rowKey}
                                rowClassName={rowClassName}
                                doubleClickRowAction={doubleClickRowAction}
                                columns={columns}
                                renderMoreActions={renderMoreActions}
                                createMoreActionCell={createMoreActionCell}
                                isSelected={selectedRowKey === row[rowKey]}
                                onRowSelect={handleRowSelect}
                            />
                        )})}
                </tbody>
            </table>
        </div>
    );
};